import type { PersonaCardBehaviorComponentProps } from "./components/PersonaCardBehavior";
import type { PersonaControlProps } from "./components/PersonaControlProps";
import type { PersonaProps } from "@fluentui/react-components";
import type { PersonaSize } from "@fluentui/react";
import type * as lazyIndex from "./lazyIndex";
import { LazyImport, LazyModule, LazyAction, createLazyComponent, type LazyComponent, } from "owa-bundling";
import type { JSX } from "react";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaPersona" */ "./lazyIndex"), { name: "OwaPersona" });

export const lazyPerformShadowPdvValidation: LazyAction<typeof lazyIndex.performShadowPdvValidation, typeof lazyModule> = new LazyAction(lazyModule, m => m.performShadowPdvValidation);

export const lazyGetLPCAccountCallbacks: LazyAction<typeof lazyIndex.getLPCAccountCallbacks, typeof lazyModule> = new LazyAction(lazyModule, m => m.getLPCAccountCallbacks);

export const lazyLpcV2CallbacksEnhancer: LazyAction<typeof lazyIndex.lpcV2CallbacksEnhancer, typeof lazyModule> = new LazyAction(lazyModule, m => m.lpcV2CallbacksEnhancer);

export const lazyIsCAPIv3Enabled: LazyAction<typeof lazyIndex.isCAPIv3Enabled, typeof lazyModule> = new LazyAction(lazyModule, m => m.isCAPIv3Enabled);

export const lazyMakeAddOrEditContactV3Callback: LazyAction<typeof lazyIndex.makeAddOrEditContactV3Callback, typeof lazyModule> = new LazyAction(lazyModule, m => m.makeAddOrEditContactV3Callback);

export const lazyCheckAndInitializeLivePersonaEditor: LazyAction<typeof lazyIndex.checkAndInitializeLivePersonaEditor, typeof lazyModule> = new LazyAction(lazyModule, m => m.checkAndInitializeLivePersonaEditor);

export const lazyOnPersonaUpdated: LazyImport<typeof lazyIndex.onPersonaUpdated, typeof lazyModule> = new LazyImport(lazyModule, m => m.onPersonaUpdated);

export const lazyGetContactEditorRenderer: LazyAction<typeof lazyIndex.getContactEditorRenderer, typeof lazyModule> = new LazyAction(lazyModule, m => m.getContactEditorRenderer);

export const lazyGetEmbeddedExpandedViewAccountId: LazyAction<typeof lazyIndex.getEmbeddedExpandedViewAccountId, typeof lazyModule> = new LazyAction(lazyModule, m => m.getEmbeddedExpandedViewAccountId);

export const lazySetIsPersonaCardOpen: LazyAction<typeof lazyIndex.setIsPersonaCardOpen, typeof lazyModule> = new LazyAction(lazyModule, m => m.setIsPersonaCardOpen);

export const PersonaControl: LazyComponent<Omit<PersonaControlProps, "size"> & {
    size?: PersonaSize | PersonaProps["size"];
}, unknown, void> = createLazyComponent(lazyModule, m => m.PersonaControl);

function PersonaCardBehaviorPlaceholder(props: PersonaCardBehaviorComponentProps): JSX.Element | null {
    return props.renderLazyPlaceholder?.(props) ?? null;
}

export const PersonaCardBehavior: LazyComponent<PersonaCardBehaviorComponentProps, unknown, void> = createLazyComponent(lazyModule, m => m.PersonaCardBehavior, PersonaCardBehaviorPlaceholder);
